import '@polymer/paper-input/paper-input-container.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-input/paper-textarea.js';
import '@polymer/paper-dialog/paper-dialog.js';
import '@polymer/paper-checkbox/paper-checkbox.js';
import 'iron-a11y-keys/iron-a11y-keys.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '@polymer/iron-icons/maps-icons.js';
import '@polymer/iron-icons/image-icons.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import '../katapult-drop-down/katapult-drop-down.js';
import '../katapult-drop-down/katapult-multi-drop-down.js';
import '../katapult-elements/katapult-button.js';
import '../file-input/file-input.js';
import '../job-chooser/job-chooser.js';
import '../user-chip/user-chip.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings.js';
import { CamelCase } from '../../modules/CamelCase.js';
import { KatapultModel } from '../../modules/katapult-model/KatapultModel.js';
import '../style-modules/paper-tooltip-style.js';
import '../style-modules/paper-dialog-style.js';
import '../style-modules/katapult-scrollbars.js';
import '../style-modules/paper-table-style.js';
import { GetNewAttributeValue } from '../../modules/GetNewAttributeValue.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { PolymerElement, html } from '@polymer/polymer';
import { FormatDate } from '../../modules/Date.js';
import { ToArray } from '../../modules/ToArray.js';
import { DeepEqual } from '../../modules/DeepEqual.js';
import { Path } from '../../modules/Path.js';
import { OpenPage } from '../../modules/OpenPage.js';
import { UserCanEditModel } from '../../modules/UserCanEditModels.js';
import { dateToMsInTimeZone, msToDateTimeInTimeZone } from '../../modules/TimeZoneDate.js';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import { html as litHtml } from 'lit-element';
import { when } from 'lit/directives/when.js';
import { KatapultDropDown } from '../katapult-drop-down/katapult-drop-down.js';
import { KatapultMultiDropDown } from '../katapult-drop-down/katapult-multi-drop-down.js';

/** @import { PolymerDeepPropertyChange } from '@polymer/polymer/interfaces.js' */

/**
 * An array of GUI elements that may have validation.
 * @type {string[]}
 */
const GUI_ELEMENTS_WITH_VALIDATION = ['textbox'];

class InputElement extends mixinBehaviors([DefaultComputedBindings], PolymerElement) {
  static get template() {
    return html` <style include="paper-tooltip-style paper-dialog-style katapult-scrollbars paper-table-style">
        :host {
          display: block;
          --primary-text-color: var(--paper-grey-900);
          --input-element-font-size: 12pt;
          --primary-color: var(--secondary-color);
        }
        paper-input, paper-textarea, paper-money-input-ench {
          flex-grow: 1;
          margin: 0;
          --paper-input-container-input: {
            font-size:var(--input-element-font-size);
          };
          --paper-input-container-label: {
            font-size:var(--input-element-font-size);
          };
          --paper-input-container-disabled: {
            opacity: 0.8;
          };
          --paper-input-container-underline-invalid: {
            /* display: none; */
            background-color: purple;
          };
        }
        /* If the current input element is on a photo, then we want to add these properties
        to make sure the textarea wraps properly. */
        paper-textarea[parent-id='photo'] {
          --paper-input-container-input: {
            overflow-wrap: normal;
            font-size:var(--input-element-font-size);
          };
          max-width: 240px;
        }

        paper-input[readonly], paper-textarea[readonly], paper-money-input-ench[readonly] {
          --paper-input-container-input: {
            opacity: 0.8;
          };
          --paper-input-container-underline: {
            border-bottom: 1px dashed gray;
          }
          --paper-input-container-underline-focus: {
            border-bottom: 1px dashed gray;
          }
        }

        paper-money-input-ench {
          --paper-money-input-ench-prefix: {
            color:var(--primary-text-color);
          }
        }
        paper-input > span {
          opacity: 0.8;
          font-weight: lighter;
          font-size: 11pt;
          color: var(--primary-color);
        }
        file-input {
          width: inherit;
          --file-input-font-size: var(--input-element-font-size);
          --file-input-filename: {
            height: 24px;
          };
          --paper-input-container-disabled: {
            opacity: 0.8;
          };
        }
        katapult-drop-down, katapult-multi-drop-down {
          flex-grow: 1;
          @apply(--drop-down-style);
          --katapult-drop-down-font-size: var(--input-element-font-size);
          --paper-input-container-disabled: {
            opacity: 0.8;
          };
        }

        /*paper-checkbox:focus {*/
        /*  outline:1px solid #003E51;*/
        /*}
        paper-checkbox::shadow #checkbox.checked {
          background-color: #009688;
          border-color: #009688;
          opacity:1;
        } */
        paper-checkbox {
          /* margin: 18px; */
          --paper-checkbox-checkmark-color: var(--input-element-paper-checkbox-checkmark-color);
          @apply(--input-element-paper-checkbox);
        }
        h6 {
          color: #333;
          font-size: var(--input-element-font-size);
          font-weight: normal;
          margin: 0;
          margin-right: 12px;
        }

        h6.hidden {
          color: #b1b1b1;
        }

        #input {
          width: 100%;
          display: flex;
          align-items:center;
          min-height: 40px;
          /* white-space: nowrap; */ /* Makes textarea not wrap properly */
          overflow: hidden;
          text-overflow: ellipsis;
          @apply --input-element-input
        }
        #input.hidden {
          margin:0;
        }
        #input.topLabel {
          flex-direction: column;
          align-items: flex-start;
          margin-top: 20px;
          margin-bottom: 10px;
        }
        .collapseContainer {
          width: 100%;
          display: flex;
        }
        .attributeName {
          color: var(--secondary-text-color, var(--paper-grey-700));
          font-weight: normal;
          padding-right: 8px;
          white-space: pre;
          margin: 0 0.5em 0 0;
          @apply(--attribute-name);
        }
        .timeZoneLabel {
          color: var(--secondary-text-color, var(--paper-grey-700));
          font-size: 10px;
          font-style: italic;
        }
        .attributeName[normal-white-space] {
          white-space: normal;
        }
        .smallButton {
          min-width:0;
          height:28px;
          width:50px;
        }
        .checkboxLabel {
          color: var(--secondary-text-color, var(--paper-grey-700));
          font-weight: normal;
          font-size: 16px;
          margin: 0 0 0 0.5em;
        }
        .timeInfo {
          display:inline-block;
          vertical-align:bottom;
          margin:0;
        }
        .emailInfo {
          margin-top:0;
        }
        paper-tooltip {
          --paper-tooltip_-_color: var(--paper-grey-800);
        }
        paper-date-picker {
          --paper-date-picker-heading:{
            display:none;
          };
        }
        #tileContainer {
          display: flex;
          flex-direction: column;
        }
        .tile {
          padding: 5px 0;
          margin: 5px;
          min-width: 50px;
        }
        span[slot="prefix"]:not(:empty) {
          margin-right:10px;
        }
        span[slot="suffix"]:not(:empty) {
          margin-left:10px;
        }
        #objectInputs {
          flex-direction: column
          display:flex;
          width:100%;
        }
        #groupInputs {
          display:flex;
          width:100%;
        }
        #groupInputs input-element {
          flex-grow:1;
        }
        #groupInputs input-element:not(:first-of-type) {
          margin-left:10px;
        }
        #element {
          @apply --input-element-element;
        }
        paper-table {
          border-radius: 16px;
          overflow: hidden;
          border: 1px solid var(--paper-grey-100);
          margin: 8px 0;
        }
        paper-row:nth-child(odd) {
          background-color: var(--paper-grey-100);
        }
        a {
          color:var(--primary-text-color);
        }
        #poleTagText {
          margin:0 10px;
          min-width:100px;
          @apply --input-element-pole-tag-text;
        }
        katapult-button:not([iconOnly]) {
          min-width: 75px;
        }
      </style>
      <template is="dom-if" if="[[calcShowElement(model, disabled, hideOnDisabled, value)]]">
        <div id="input" class$="{{_computeClass(gui_element, topLabel)}}">
          <iron-collapse horizontal opened$="{{showHelp}}">
            <sl-tooltip content="No info configured for this attribute" disabled="[[!getHelpButtonDisabled(model, userCanEditModel)]]">
              <div>
                <katapult-button
                  id="helpButton"
                  iconOnly
                  noBorder
                  icon="help"
                  icon-config="[[getHelpButtonIconConfig(model, userCanEditModel)]]"
                  disabled="[[getHelpButtonDisabled(model, userCanEditModel)]]"
                  on-click="attributeInfoButtonClickHandler"
                ></katapult-button>
              </div>
            </sl-tooltip>
          </iron-collapse>
          <template is="dom-if" if="{{!hideAttributeName}}">
            <!-- prettier-ignore -->
            <h6
              class="attributeName"
              hidden$="{{calcElementIsHidden(gui_element)}}"
              title="{{placeholder}}"
              normal-white-space$="[[normalWhiteSpace]]"
            >[[_label]]</h6>
          </template>
          <slot name="label"></slot>
          <template is="dom-if" if="[[showInfoButton(model)]]" restamp>
            <sl-tooltip content="[[getInfoButtonTooltip(model)]]" placement="bottom" distance="0">
              <katapult-button
                size="18"
                icon="info"
                iconOnly
                noBorder
                noBackground
                on-click="handleInfoButtonClick"
                style="margin-left: -16px;"
              ></katapult-button>
            </sl-tooltip>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'dropdown')}}" restamp>
            <katapult-drop-down
              id="element"
              items="[[picklist]]"
              value="{{_value}}"
              label="[[placeholder]]"
              label-function="[[boundGetPicklistItemLabel]]"
              mobile="{{mobile}}"
              null-value=""
              fit-into="[[fitInto]]"
              value-path="[[valueKey]]"
              secondary-label-path="description"
              display-shortname="[[displayShortname]]"
              invalid="[[invalid]]"
              no-label-float="[[noLabelFloat]]"
              show-last-results="[[searchNotEmpty]]"
              show-value-as-label=""
              only-open-down="[[onlyOpenDown]]"
              on-input-focus="focusSearch"
              on-opened-changed="openedChanged"
              no-clear="[[noClear]]"
              on-selected-changed="enterPressed"
              readonly$="[[_disabled]]"
              on-icon-click="dropdownIconClick"
            >
              <template is="dom-if" if="[[shouldShowAllOptionsButton(selectedPicklist, noShowAllOptions)]]" restamp>
                <paper-item on-click="showAllOptions">SHOW ALL OPTIONS</paper-item>
              </template>
              <template is="dom-if" if="[[canAddAttribute]]" restamp>
                <paper-item on-click="addNewAttribute">Add New [[getCamelCase(attribute_name, camelCase)]]</paper-item>
              </template>
              <template is="dom-if" if="[[equal(attribute_name, 'company')]]" restamp>
                <paper-item on-click="addOtherCompany">Other Company</paper-item>
              </template>
            </katapult-drop-down>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'multi_dropdown')}}" restamp>
            <katapult-multi-drop-down
              id="element"
              items="[[picklist]]"
              value="{{_value}}"
              label="[[placeholder]]"
              label-function="[[boundGetPicklistItemLabel]]"
              mobile="{{mobile}}"
              null-value=""
              fit-into="[[fitInto]]"
              value-path="[[valueKey]]"
              secondary-label-path="description"
              display-shortname="[[displayShortname]]"
              invalid="[[invalid]]"
              no-label-float="[[noLabelFloat]]"
              show-last-results="[[searchNotEmpty]]"
              show-value-as-label=""
              only-open-down="[[onlyOpenDown]]"
              on-input-focus="focusSearch"
              on-opened-changed="openedChanged"
              on-selected-changed="enterPressed"
              readonly$="[[_disabled]]"
              allow-duplicates="[[model.allow_duplicates]]"
              display-vertically="[[or(model.display_vertically, mobile)]]"
            >
              <template is="dom-if" if="[[shouldShowAllOptionsButton(selectedPicklist, noShowAllOptions)]]" restamp>
                <paper-item on-click="showAllOptions">SHOW ALL OPTIONS</paper-item>
              </template>
              <template is="dom-if" if="[[canAddAttribute]]" restamp>
                <paper-item on-click="addNewAttribute">Add New [[getCamelCase(attribute_name, camelCase)]]</paper-item>
              </template>
              <template is="dom-if" if="[[equal(attribute_name, 'company')]]" restamp>
                <paper-item on-click="addOtherCompany">Other Company</paper-item>
              </template>
            </katapult-multi-drop-down>
          </template>
          <template is="dom-if" if="{{calcShowTextbox(gui_element, _disabled)}}" restamp>
            <paper-input
              class="disableUnderline"
              id="element"
              label="{{placeholder}}"
              value="[[_value]]"
              on-focus="selectText"
              readonly$="{{_disabled}}"
              invalid="[[invalid]]"
              error-message="[[_stampErrorMessage(invalid, isMobileAssessmentInput, model.validation.error_message)]]"
              no-label-float="[[noLabelFloat]]"
              on-keydown="keyPressed"
              type="{{model.type}}"
              min="{{model.min}}"
              max="{{model.max}}"
              maxlength="512"
              step="{{model.step}}"
              allowed-pattern="[^\`]"
              on-value-changed="validate"
              on-change="_set_value"
            >
              <span slot="prefix">[[model.prefix]]</span>
              <span slot="suffix">[[model.suffix]]</span>
            </paper-input>
          </template>
          <template is="dom-if" if="[[calcShowTextboxCommit(gui_element, _disabled)]]" restamp>
            <paper-input
              class="disableUnderline"
              id="element"
              label="{{placeholder}}"
              value="[[_value]]"
              on-focus="selectText"
              readonly$="{{_disabled}}"
              invalid="{{invalid}}"
              no-label-float="[[noLabelFloat]]"
              on-keydown="keyPressed"
              type="{{model.type}}"
              min="{{model.min}}"
              max="{{model.max}}"
              maxlength="512"
              step="{{model.step}}"
              allowed-pattern="[^\`]"
              on-value-changed="textboxCommitChanged"
            >
              <span slot="prefix">[[model.prefix]]</span>
              <span slot="suffix">[[model.suffix]]</span>
            </paper-input>
            <iron-collapse opened="[[showTextboxCommitButtons]]" horizontal style="display: flex;">
              <katapult-button
                icon="close"
                iconOnly
                noBorder
                style="padding: 0; margin-left: 8px;"
                on-click="discardValueChange"
              ></katapult-button>
              <katapult-button
                icon="done"
                iconOnly
                noBorder
                style="padding: 0; margin-left: 8px;"
                on-click="commitValueChange"
              ></katapult-button>
            </iron-collapse>
          </template>
          <template is="dom-if" if="{{calcShowTextarea(gui_element, _disabled)}}" restamp>
            <!-- TODO: We should be able to use on-change here like we did for the paper input, but paper-textarea has a bug -->
            <!-- where it does not fire that event properly. Instead, we're checking for some other things, like on-blur and <ctrl> <enter>. -->
            <paper-textarea
              id="element"
              label="{{placeholder}}"
              readonly$="{{_disabled}}"
              invalid="{{invalid}}"
              no-label-float="[[noLabelFloat]]"
              value="[[_value]]"
              maxlength="2048"
              on-focus="selectText"
              on-keydown="handleTextareaKeydown"
              on-blur="_set_value"
              parent-id$="[[fitInto.id]]"
            ></paper-textarea>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'money')}}" restamp>
            <paper-money-input-ench
              id="element"
              label="{{placeholder}}"
              value="{{_value}}"
              readonly$="{{_disabled}}"
              invalid="{{invalid}}"
              precision="{{model.precision}}"
              max-value="Infinity"
              on-focus="selectText"
              no-label-float="[[noLabelFloat]]"
            ></paper-money-input-ench>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'checkbox')}}" restamp>
            <paper-checkbox id="element" checked="{{_value}}" disabled$="{{_disabled}}" invalid="{{invalid}}">
              <template is="dom-if" if="[[checkboxLabels]]"><span class="checkboxLabel">{{placeholder}}</span></template>
              <iron-a11y-keys keys="enter" on-keys-pressed="enterPressed"></iron-a11y-keys>
            </paper-checkbox>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'coordinate_capture')}}" restamp>
            <katapult-button
              icon="{{getModelIcon(model)}}"
              iconOnly
              noBorder
              on-click="buttonClick"
              style$="{{_computeStyle(model)}}"
            ></katapult-button>
            <template is="dom-if" if="{{_value}}">
              <template is="dom-if" if="{{!_value.latitude}}">
                <div>
                  <template is="dom-repeat" items="{{objectKeys(_value)}}" as="label">
                    <div>
                      <span>{{label}}</span>: <span>{{_computeExpression6(_value, label)}}</span>,
                      <span>{{_computeExpression7(_value, label)}}</span>
                    </div>
                  </template>
                </div>
              </template>
              <template is="dom-if" if="{{_value.latitude}}">
                <h6><span>{{_value.latitude}}</span>, <span>{{_value.longitude}}</span></h6>
              </template>
            </template>
          </template>

          <template is="dom-if" if="{{equal(gui_element, 'span')}}" restamp>
            <span>{{_value.text}}</span>
          </template>

          <template is="dom-if" if="{{equal(gui_element, 'timer')}}" restamp>
            <div style="display: flex; align-items: center;">
              <template is="dom-if" if="{{_value}}">
                <paper-table>
                  <paper-row>
                    <paper-cell>
                      <h6 class="timeInfo">
                        <span>{{getDate(_value)}}</span><span>{{formatTime(_value.start)}}</span> - <span>{{formatTime(_value.stop)}}</span>
                      </h6>
                    </paper-cell>
                  </paper-row>
                  <template is="dom-if" if="[[_hasTeamMembers(_value, _value.*)]]">
                    <template is="dom-repeat" items="[[cleanTeamMembers(_value.teamMembers.team)]]">
                      <paper-row>
                        <paper-cell>
                          <user-chip uid="[[item.uid]]"></user-chip>
                        </paper-cell>
                        <paper-cell>
                          <div>[[item.role]]</div>
                        </paper-cell>
                      </paper-row>
                    </template>
                  </template>
                  <template is="dom-if" if="[[!_hasTeamMembers(_value, _value.*)]]">
                    <paper-row>
                      <paper-cell>
                        <user-chip uid="[[_value.uid]]"></user-chip>
                      </paper-cell>
                    </paper-row>
                  </template>
                </paper-table>
              </template>
            </div>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'job_chooser')}}" restamp>
            <job-chooser
              id="element"
              selected="{{_value}}"
              disabled$="{{_disabled}}"
              firebase-disabled="{{firebaseDisabled}}"
              user-group="{{userGroup}}"
            ></job-chooser>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'pole_tag')}}" restamp>
            <katapult-drop-down
              id="element"
              items="[[picklist]]"
              value="{{_value.company}}"
              label-path="[[labelKey]]"
              value-path="[[valueKey]]"
              mobile="[[mobile]]"
              null-value=""
              only-open-down="[[onlyOpenDown]]"
              readonly$="{{_disabled}}"
              invalid="{{invalid}}"
              show-value-as-label=""
              show-last-results="[[searchNotEmpty]]"
              no-clear="[[noClear]]"
              no-label-float="[[noLabelFloat]]"
            >
            </katapult-drop-down>
            <paper-input
              id="poleTagText"
              label="[[placeholder]]"
              value="[[_value.tagtext]]"
              on-focus="selectText"
              readonly$="[[_disabled]]"
              invalid="[[invalid]]"
              no-label-float="[[noLabelFloat]]"
              maxlength="512"
              data-set-subpath=".tagtext"
              on-change="_set_value"
            >
              <iron-a11y-keys keys="enter" on-keys-pressed="enterPressed"></iron-a11y-keys>
              <span slot="prefix">[[model.prefix]]</span>
              <span slot="suffix">[[model.suffix]]</span>
            </paper-input>
            <paper-checkbox id="element" checked="{{_value.owner}}" disabled$="{{_disabled}}">
              <paper-tooltip animation-delay="0" position="[[tooltipPosition]]">Pole Owner</paper-tooltip>
              <iron-a11y-keys keys="enter" on-keys-pressed="enterPressed"></iron-a11y-keys>
            </paper-checkbox>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'power_consumption')}}" restamp>
            <paper-input
              style="margin-right: 8px;"
              type="number"
              step="0.1"
              min="0"
              no-label-float
              label="Power"
              disabled="[[_value.unknown]]"
              value="[[_value.kva]]"
              data-set-subpath=".kva"
              on-change="_set_value"
            >
              <span slot="suffix">kVA</span>
            </paper-input>
            <paper-input
              style="margin-right: 8px;"
              no-label-float
              label="Note"
              value="[[_value.note]]"
              maxlength="512"
              data-set-subpath=".note"
              on-change="_set_value"
            ></paper-input>
            <paper-checkbox checked="{{_value.unknown}}">
              <paper-tooltip animation-delay="0" position="[[tooltipPosition]]">Unknown</paper-tooltip>
            </paper-checkbox>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'date-time')}}" restamp>
            <date-time-picker
              style="margin-bottom: -20px;"
              id="element"
              time="{{_value}}"
              on-submit="enterPressed"
              no-default-date="[[noDefaultDate]]"
            ></date-time-picker>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'date-time-dialog')}}" restamp>
            <date-time-dialog
              id="element"
              value="{{_value}}"
              on-submit="enterPressed"
              date-string-format="[[dateStringFormat]]"
              fit-into="[[fitInto]]"
              horizontal-offset="[[horizontalOffset]]"
              horizontal-align="[[horizontalAlign]]"
              label="[[placeholder]]"
              no-label-float="[[noLabelFloat]]"
              no-default-date="[[noDefaultDate]]"
            ></date-time-dialog>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'user-dropdown')}}" restamp>
            <firebase-query
              id="users"
              path="photoheight/company_space/{{userGroup}}/users"
              data="{{userList}}"
              disabled="[[firebaseDisabled]]"
            ></firebase-query>
            <katapult-firebase-worker
              path="photoheight/company_space/{{userGroup}}/external_users"
              data="{{externalUsers}}"
              disabled="[[firebaseDisabled]]"
            ></katapult-firebase-worker>
            <katapult-drop-down
              id="element"
              items="[[filteredUserList]]"
              value="{{_value}}"
              label="[[placeholder]]"
              mobile="{{mobile}}"
              null-value=""
              only-open-down="[[onlyOpenDown]]"
              label-path="email"
              value-path="uid"
              on-selected-changed="enterPressed"
              readonly$="{{_disabled}}"
              invalid="{{invalid}}"
              show-value-as-label=""
              show-last-results="{{searchNotEmpty}}"
              no-clear="[[noClear]]"
              no-label-float="[[noLabelFloat]]"
            >
              <template is="dom-if" if="[[filterToTimeBucketUsers]]" restamp>
                <paper-item on-click="showAllUsers">SHOW ALL USERS</paper-item>
              </template>
              <template is="dom-if" if="[[showTimeBucketUsersOption]]" restamp>
                <paper-item on-click="showTimeBucketUsers">SHOW ONLY TIME BUCKET USERS</paper-item>
              </template>
            </katapult-drop-down>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'node-dropdown')}}" restamp>
            <katapult-drop-down
              id="element"
              items="[[nodeList]]"
              value="{{_value}}"
              label="[[placeholder]]"
              mobile="{{mobile}}"
              null-value=""
              only-open-down="[[onlyOpenDown]]"
              label-function="[[nodeLabelFunction]]"
              value-path="$key"
              on-selected-changed="enterPressed"
              readonly$="{{_disabled}}"
              invalid="{{invalid}}"
              show-value-as-label=""
              show-last-results="{{searchNotEmpty}}"
              no-clear="[[noClear]]"
              no-label-float="[[noLabelFloat]]"
            >
            </katapult-drop-down>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'calibrated-width')}}" restamp>
            <paper-input
              id="element"
              type="number"
              min="[[model.min]]"
              max="[[model.max]]"
              step="[[model.step]]"
              no-label-float="[[noLabelFloat]]"
              readonly$="[[_disabled]]"
              invalid="[[invalid]]"
              maxlength="512"
              value="[[_value]]"
              on-change="_set_value"
            >
              <span slot="prefix">[[model.prefix]]</span>
              <span slot="suffix">[[model.suffix]]</span>
            </paper-input>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'tiles')}}" restamp>
            <div id="tileContainer">
              <template is="dom-repeat" items="{{getTiles(_value)}}" as="tile">
                <katapult-button size="18" class="tile" on-click="deleteTile">{{tile}}</katapult-button>
              </template>
            </div>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'file')}}" restamp>
            <file-input
              path="photoheight/jobs/[[jobId]]/files/[[getFileInputPath(fileInputPath, attribute_name, model.path)]]"
              job-id="[[jobId]]"
              files="{{files}}"
              label="[[placeholder]]"
              multiple="[[model.multiple]]"
              accept="[[model.accept]]"
              disabled="[[_disabled]]"
              upload-automatically="[[model.upload_automatically]]"
              invalid="{{invalid}}"
              on-file-uploaded="fireFileEvent"
              on-file-deleted="fireFileEvent"
            ></file-input>
          </template>
          <template is="dom-if" if="[[equal(gui_element, 'link')]]" restamp>
            <template is="dom-if" if="[[shouldShowLinkEditInput(editingLink, _value, _disabled)]]" restamp>
              <paper-input
                class="disableUnderline"
                id="element"
                label="{{placeholder}}"
                value="[[_value]]"
                on-focus="selectText"
                readonly$="[[_disabled]]"
                invalid="[[invalid]]"
                error-message="[[_stampErrorMessage(invalid, isMobileAssessmentInput, model.validation.error_message)]]"
                no-label-float="[[noLabelFloat]]"
                on-keypress="keyPressed"
                maxlength="512"
                step="{{model.step}}"
                allowed-pattern="[^\`]"
                on-value-changed="validate"
                on-change="_set_value"
                on-blur="_onLinkBlur"
              >
                <span slot="prefix">[[model.prefix]]</span>
                <span slot="suffix">[[model.suffix]]</span>
              </paper-input>
            </template>
            <template is="dom-if" if="[[!shouldShowLinkEditInput(editingLink, _value, _disabled)]]" restamp>
              <div style="flex-grow: 1; overflow-wrap: break-word; overflow: hidden;">
                <a href$="[[_value]]" target="_blank" rel="noopener noreferrer">[[_value]]</a>
              </div>
              <katapult-button
                icon="create"
                iconOnly
                size="small"
                disabled="[[_disabled]]"
                noBorder
                style="flex-shrink: 0; float: right"
                on-click="editLink"
              ></katapult-button>
            </template>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'job-link')}}" restamp>
            <!-- TODO: ensure that this works in chrome with tab grouping and that IndexedDB doesn't get confused by using this link -->
            <katapult-firebase-worker path="photoheight/jobs/[[_value]]/name" data="{{jobLinkLabel}}"> </katapult-firebase-worker>
            <a href="" on-click="openJob">[[jobLinkLabel]]</a>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'date')}}" restamp>
            <div style="width: 100%; display:flex; flex-direction:column;">
              <paper-input
                label="[[getDateLabel(placeholder, noLabelFloat)]]"
                disabled="[[_disabled]]"
                no-label-float="[[noLabelFloat]]"
                type="date"
                invalid="[[invalid]]"
                maxlength="512"
                value="[[formatInputDate(_value, modelTimeZone)]]"
                on-value-changed="setDateToValue"
              ></paper-input>
              <span class="timeZoneLabel">[[modelTimeZone]]</span>
            </div>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'cost-causer')}}" restamp>
            <katapult-cost-causer-input value="{{_value}}" companies="[[picklist]]" disabled="[[_disabled]]"></katapult-cost-causer-input>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'team-members')}}" restamp>
            <katapult-team-members-input
              style="flex-grow:1; flex-shrink:1;"
              value="{{_value}}"
              user-group="[[userGroup]]"
              other-attributes="[[otherAttributes]]"
              username-only="[[usernameOnly]]"
              time-bucket-users="[[timeBucketUsers]]"
              time-bucket-roles="[[timeBucketRoles]]"
              filter-to-time-bucket-users="[[filterToTimeBucketUsers]]"
              filter-to-time-bucket-roles="[[filterToTimeBucketRoles]]"
              show-time-bucket-user-options="[[showTimeBucketUsersOption]]"
            ></katapult-team-members-input>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'object')}}" restamp>
            <div id="objectInputs">
              <template is="dom-repeat" items="[[model.properties]]">
                <paper-input
                  id="element"
                  class="disableUnderline"
                  label="[[item.label]]"
                  value="[[getObjectValue(_value, item)]]"
                  on-focus="selectText"
                  readonly$="[[_disabled]]"
                  invalid="[[invalid]]"
                  type="[[model.type]]"
                  min="[[model.min]]"
                  max="[[model.max]]"
                  step="[[model.step]]"
                  allowed-pattern="[^\`]"
                  maxlength="512"
                  on-keydown="keyPressed"
                  on-change="objectValueChange"
                >
                  <span slot="prefix">[[model.prefix]]</span>
                  <span slot="suffix">[[model.suffix]]</span>
                </paper-input>
              </template>
            </div>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'group')}}" restamp>
            <div id="groupInputs">
              <template is="dom-repeat" items="[[model.properties]]">
                <input-element
                  attribute_name="[[item.property]]"
                  hide-attribute-name="[[hideAttributeName]]"
                  model="[[getModel(item.property, otherAttributes)]]"
                  user-group="[[userGroup]]"
                  value=""
                  label="[[item.label]]"
                  disabled="[[_disabled]]"
                  invalid="[[invalid]]"
                  firebase-disabled="[[firebaseDisabled]]"
                  on-input-element-change="groupValueChange"
                  job-creator="[[jobCreator]]"
                >
                </input-element>
              </template>
            </div>
          </template>
          <template is="dom-if" if="{{equal(gui_element, 'table')}}" restamp>
            <paper-table white outline rounded dividers style="width: 100%; box-sizing: border-box;">
              <template is="dom-if" if="[[!model.hide_header]]">
                <paper-row short grey>
                  <template is="dom-repeat" restamp items="[[model.table_items]]">
                    <template is="dom-if" if="[[showTableHeader(item.display, item.type, _disabled)]]" restamp>
                      <paper-cell>[[calcTableHeaderLabel(item.attribute, camelCase, otherAttributes.*)]]</paper-cell>
                    </template>
                  </template>
                  <template is="dom-if" if="[[!_disabled]]">
                    <paper-cell icon></paper-cell>
                  </template>
                </paper-row>
              </template>
              <template is="dom-repeat" restamp items="[[filteredObjectKeys(_value, _value.*)]]" as="row">
                <paper-row style="background-color: white; display:flex; height: fit-content;">
                  <template is="dom-repeat" restamp items="[[model.table_items]]">
                    <template is="dom-if" if="[[item.display]]" restamp>
                      <template is="dom-if" if="[[showIconButton(item.type, _disabled)]]" restamp>
                        <paper-cell style="padding: 2px">
                          <katapult-button
                            id="tableIconButton[[index]]"
                            icon="[[item.icon]]"
                            iconOnly
                            noBorder
                            on-click="tableButtonAction"
                          ></katapult-button>
                          <paper-tooltip for="tableIconButton[[index]]">[[item.tooltip]]</paper-tooltip>
                        </paper-cell>
                      </template>
                      <template is="dom-if" if="[[!item.type]]" restamp>
                        <paper-cell style="padding: 1px">
                          <input-element
                            class="input"
                            id="[[item.attribute]]"
                            attribute_name="[[item.attribute]]"
                            value="[[of(_value, row, item.attribute, _value.*)]]"
                            is_required="[[item.required]]"
                            cond_required="[[item.required_if]]"
                            model="[[of(otherAttributes, item.attribute)]]"
                            other-attributes="[[otherAttributes]]"
                            on-value-changed="tableValueChanged"
                            user-group="[[userGroup]]"
                            style="flex-grow: 1; margin: 5px;"
                            hide-attribute-name
                            no-label-float
                            disabled="[[_disabled]]"
                            camel-case
                            job-creator="[[jobCreator]]"
                          ></input-element>
                        </paper-cell>
                      </template>
                    </template>
                  </template>
                  <template is="dom-if" if="[[!_disabled]]">
                    <paper-cell icon>
                      <katapult-button
                        icon="create"
                        iconOnly
                        noBorder
                        style="flex-shrink:0;"
                        callback="openTable"
                        noSuccess
                      ></katapult-button>
                    </paper-cell>
                  </template>
                </paper-row>
              </template>
              <template is="dom-if" if="[[!model.hide_add_row]]">
                <template is="dom-if" if="[[!_disabled]]" restamp>
                  <paper-row short ripple style="background-color: white;">
                    <paper-cell
                      pointer
                      style="justify-content: center; gap: 4px; color: var(--primary-text-color-faded);"
                      on-click="addTableRow"
                    >
                      <span>Add Row</span>
                      <katapult-icon icon="add_circle"></katapult-icon>
                    </paper-cell>
                  </paper-row>
                </template>
              </template>
            </paper-table>
            <table-attribute-editor
              id="tableEditor"
              other-attributes="[[otherAttributes]]"
              value="{{_value}}"
              item-key="{{itemKey}}"
              job-creator="[[jobCreator]]"
            ></table-attribute-editor>
          </template>
          <!-- No model; show an input if value is string, read-only display if non-string -->
          <template is="dom-if" if="[[noModel]]" restamp>
            <template is="dom-if" if="[[!isString(_value)]]">
              <div style="padding:10px;">[[getTextValue(_value)]]</div>
            </template>
            <template is="dom-if" if="[[isString(_value)]]">
              <paper-input
                class="disableUnderline"
                id="element"
                value="[[_value]]"
                on-focus="selectText"
                label="No model exists for this attribute"
                readonly$="{{_disabled}}"
                invalid="{{invalid}}"
                no-label-float="[[noLabelFloat]]"
                type="text"
                allowed-pattern="[^(\`|~)]"
                maxlength="512"
                on-keydown="keyPressed"
                on-change="_set_value"
              >
                <span slot="prefix">[[model.prefix]]</span>
                <span slot="suffix">[[model.suffix]]</span>
              </paper-input>
            </template>
          </template>
        </div>
      </template>
      <template is="dom-if" if="{{_compareAttribute(attribute_name, 'sizes_of_attached_dn_guys')}}">
        <!--Down Guy Dialog-->
        <paper-dialog id="downGuyDialog" opened="{{downGuyMobileInputOpened}}">
          <div>
            <h2>Guy Details</h2>
            <div>Select number of attached down guys:</div>
            <div>
              <select value="{{number_of_attached_down_guys::change}}">
                <option disabled="" selected="">Select</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
              </select>
            </div>
            <div>Select down guy sized from top to bottom:</div>
            <template is="dom-repeat" items="{{downGuySizesArray}}">
              <div style="margin: 5px">
                <span>Guy <span>{{_addOneToNumber(item.index)}}</span></span>
                <select value="{{item.value::change}}">
                  <option disabled="" selected="">Select</option>
                  <option>4M</option>
                  <option>6.6M</option>
                  <option>6M</option>
                  <option>10M</option>
                  <option>16M</option>
                  <option>25M</option>
                </select>
              </div>
            </template>
          </div>
          <div class="buttons" style="gap:8px;">
            <katapult-button on-click="nullDownGuyInputValues">Cancel</katapult-button>
            <katapult-button color="var(--secondary-color)" on-click="nullDownGuyInputValues">Ok</katapult-button>
          </div>
        </paper-dialog>
      </template>
      <!--Other Company Dialog-->
      <template is="dom-if" if="{{_compareAttribute(attribute_name, 'company')}}" restamp>
        <paper-dialog id="otherCompanyDialog">
          <div title="" secondary-color="">Other Company</div>
          <div content="">
            <paper-input id="otherCompanyInput" label="Other Company Name"></paper-input>
          </div>
          <div class="buttons" style="gap:8px;">
            <katapult-button dialog-dismiss>Close</katapult-button>
            <katapult-button color="var(--secondary-color)" dialog-confirm on-click="addOtherCompanyConfirm">Okay</katapult-button>
          </div>
        </paper-dialog>
      </template>`;
  }

  static get properties() {
    return {
      _value: {
        notify: true
      },
      attribute_name: String,
      autoFocus: {
        notify: true,
        observer: 'autoFocusChanged'
      },
      canAddAttribute: {
        type: Boolean,
        notify: true
      },
      camelCase: {
        type: Boolean,
        value: false
      },
      checkboxLabels: {
        type: Boolean,
        value: false
      },
      dateStringFormat: {
        type: Boolean
      },
      disabled: {
        type: Boolean,
        value: false
      },
      _disabled: {
        type: Boolean,
        value: false,
        observer: '_disabledChanged'
      },
      displayShortname: {
        type: Boolean,
        value: false
      },
      editingLink: {
        type: Boolean,
        value: false
      },
      firebaseDisabled: {
        type: Boolean,
        value: false
      },
      downGuyMobileEdit: {
        notify: true
      },
      editing: Boolean,
      files: {
        type: Array,
        notify: true
      },
      filterToTimeBucketRoles: {
        type: Boolean,
        value: false
      },
      filterToTimeBucketUsers: {
        type: Boolean,
        value: false
      },
      gui_element: {
        type: Object,
        observer: 'loadLazyElements'
      },
      hideAttributeName: {
        type: Boolean,
        value: false
      },
      hideOnDisabled: {
        type: Boolean,
        value: false
      },
      invalid: {
        type: Boolean,
        value: false
      },
      jobId: {
        type: String
      },
      _label: {
        type: String,
        computed: 'calcLabel(label, model.label, attribute_name, camelCase)',
        notify: true
      },
      label: {
        type: String
      },
      labelKey: {
        type: String,
        value: 'label',
        notify: true
      },
      /*can be used to force mobile dropdown*/
      mobile: {
        type: Boolean,
        value: false
      },
      noClear: {
        type: Boolean,
        value: false
      },
      noModel: {
        type: Boolean,
        value: false
      },
      model: Object,
      modelConfig: Object,
      noLabelFloat: {
        type: Boolean,
        value: false
      },
      noShowAllOptions: {
        type: Boolean,
        value: false
      },
      onlyOpenDown: {
        type: Boolean,
        value: false
      },
      otherAttributes: Object,
      picklist: { notify: true },
      placeholder: {
        type: String,
        computed: 'calcPlaceholder(label, _label, model.placeholder, modelConfig.default_attribute_placeholders)',
        notify: true
      },
      searchNotEmpty: {
        type: Boolean,
        value: true
      },
      // searchBeginning -- DEPRECATED
      selectedPicklist: {
        observer: 'modelChanged',
        value: null
      },
      showHelp: {
        type: Boolean,
        value: false
      },
      showTimeBucketUsersOption: {
        type: Boolean,
        value: false
      },
      tooltipPosition: {
        type: String,
        value: 'left'
      },
      topLabel: {
        type: Boolean,
        value: false
      },
      userGroup: String,
      usernameOnly: {
        type: Boolean,
        value: false
      },
      value: {
        notify: true
      },
      valueKey: {
        type: String,
        value: 'value',
        notify: true
      },
      fitInto: {
        type: Object
      },
      horizontalOffset: {
        type: Number
      },
      horizontalAlign: {
        type: String
      },
      itemKey: {
        type: String,
        value: '',
        notify: true,
        observer: 'itemKeyChanged'
      },
      timeBucketRoles: {
        type: Array
      },
      timeBucketUsers: {
        type: Object
      },
      text: {
        type: String,
        notify: true
      },
      num: {
        type: Number,
        notify: true
      },
      noDefaultDate: {
        type: Boolean,
        value: false
      },
      normalWhiteSpace: {
        type: Boolean,
        value: false
      },
      filteredUserList: {
        type: Array,
        computed:
          'computeFilteredUserList(userList, externalUsers, model, timeBucketUsers, filterToTimeBucketUsers, showTimeBucketUsersOption, userGroup)'
      },
      ignoreReadOnly: {
        type: Boolean,
        value: false
      },
      isMobileAssessmentInput: {
        type: Boolean,
        value: false
      },
      userCanEditModel: {
        type: Boolean,
        value: false
      }
    };
  }

  static get observers() {
    return [
      'fetchModelData(jobCreator, gui_element, firebaseDisabled)',
      'updateModelConfigFromJobCreator(jobCreator)',
      'computeDisabled(disabled, model.read_only, ignoreReadyOnly)',
      'downGuySizesArrayChanged(downGuySizesArray.*)',
      'modelChanged(model, otherAttributes)',
      'numberOfDownGuysChanged(number_of_attached_down_guys)',
      'valueChanged(value.*)',
      '_valueChanged(_value.*)',
      'validate(value.*, model.validation)',
      'computeUserCanEditModel(jobCreator, showHelp, userGroup)'
    ];
  }

  static get importMeta() {
    return import.meta;
  }

  constructor() {
    super();

    // Property and attribute initialization
    this.model = undefined;
    this.isMobileAssessmentInput = false;

    // Template helpers
    this._hasTeamMembers = (attribute) => attribute?.teamMembers?.team?.filter((x) => x?.uid || x?.role).length > 0;
    this._stampErrorMessage = (isInvalid, isMobileAssessmentInput, message) => (isInvalid || isMobileAssessmentInput ? message : '');
  }

  ready() {
    super.ready();
    this.addEventListener('keydown', this.stopPropagation.bind(this));
    this.boundGetPicklistItemLabel = this.boundGetPicklistItemLabel.bind(this);
  }

  of(a, b, c) {
    if (typeof c != 'undefined') {
      return a && a[b] && a[b][c];
    } else {
      return a && a[b];
    }
  }

  or(a, b) {
    return !!a || !!b;
  }

  objectKeys(obj) {
    return Object.keys(obj || {});
  }
  filteredObjectKeys(obj) {
    return Object.keys(obj || {}).filter((key) => obj[key] != null);
  }
  toArray(obj) {
    return ToArray(obj);
  }

  shouldShowAllOptionsButton(a, b) {
    return a && !b;
  }

  addOtherCompany() {
    this.shadowRoot.querySelector('#element')?.close?.();
    const dialog = this.shadowRoot.querySelector('#otherCompanyDialog');
    dialog.addEventListener(
      'iron-overlay-opened',
      () => {
        this.shadowRoot.querySelector('#otherCompanyInput').focus();
      },
      { once: true }
    );
    dialog.open();
  }

  addOtherCompanyConfirm() {
    const input = this.shadowRoot.querySelector('#otherCompanyInput');
    if (input.value) {
      this._value = input.value.trim();
    }
    input.value = '';
  }

  addNewAttribute() {
    this.dispatchEvent(new CustomEvent('add-new-attribute', { detail: { attribute_name: this.attribute_name } }));
  }

  cleanTeamMembers(team) {
    team = team || [];
    team = team.filter((x) => x.uid || x.role);
    team.forEach((x) => {
      if (x.role == 'Camera') x.role = '';
    });
    return team;
  }

  loadLazyElements() {
    if (this.gui_element == 'cost-causer') import('./gui_elements/katapult-cost-causer-input.js');
    else if (this.gui_element == 'team-members') import('./gui_elements/katapult-team-members-input.js');
    else if (this.gui_element == 'date-time') import('../date-time-picker/date-time-picker.js');
    else if (this.gui_element == 'date-time-dialog') import('../date-time-dialog/date-time-dialog.js');
    else if (this.gui_element == 'money') import('../../js/converted-components/paper-money-input-ench/paper-money-input-ench.js');
  }

  numberOfDownGuysChanged() {
    var downGuySizesArray = [];
    for (var i = 0; i < this.number_of_attached_down_guys; i++) {
      downGuySizesArray.push({ index: i, value: null });
    }
    this.downGuySizesArray = downGuySizesArray;
    setTimeout(() => {
      this.shadowRoot.querySelector('#downGuyDialog').notifyResize();
    });
  }

  computeFilteredUserList() {
    // If both the user list and external users object, or model doesn't exist, return an empty array
    if ((!this.userList && !this.externalUsers) || !this.model) return [];

    const externalUserList = Object.entries(this.externalUsers || {})
      .map(([uid, user]) => ({ uid, ...user, external: true }))
      .filter((user) => {
        // Filter out users that are already in the userList
        // This is a special case because we added external users to the users object for some companies as a hotfix
        return !this.userList.some((u) => u.uid == user.uid);
      });

    // If the model has a filter, filter the user list to only show users that match the filter
    if (this.model.filter) {
      let finalUserList = [...this.userList, ...externalUserList];
      for (const [propertyName, propertyValue] of Object.entries(this.model.filter)) {
        finalUserList = finalUserList.filter((user) => user[propertyName] == propertyValue);
      }
      return finalUserList;
    }

    // If the time bucket users object doesn't exist or it's empty, return the user list
    if (!this.timeBucketUsers || Object.keys(this.timeBucketUsers).length == 0) return [...this.userList, ...externalUserList];

    let finalUserList = [];

    // If the user doesn't want to filter to time bucket users, return the full user list plus the time bucket users
    if (!this.filterToTimeBucketUsers) {
      finalUserList = [...this.userList, ...externalUserList];

      const timeBucketUsersToAdd = this.findItemsToAddToArray(this.timeBucketUsers, finalUserList, 'uid');

      // Add the time bucket users to the list if they don't already exist
      for (const user of timeBucketUsersToAdd) {
        // If the user object doesn't have an email, get it from `user_info` if it exists
        if (!user.email && this.timeBucketUsers[user.uid]) user.email = this.timeBucketUsers[user.uid];
        finalUserList.push(user);
      }

      return finalUserList;
    }

    // Filter the user list to only show users that are on a time bucket in the job
    finalUserList = [
      ...this.userList.filter((user) => (this.timeBucketUsers[user.uid] ? true : false)),
      ...externalUserList.filter((user) => (this.timeBucketUsers[user.uid] ? true : false))
    ];

    const timeBucketUsersToAdd = this.findItemsToAddToArray(this.timeBucketUsers, finalUserList, 'uid');

    // Add the time bucket users to the list if they don't already exist
    for (const user of timeBucketUsersToAdd) {
      // If the user object doesn't have an email, get it from `user_info` if it exists
      if (!user.email && this.timeBucketUsers[user.uid]) user.email = this.timeBucketUsers[user.uid];
      finalUserList.push(user);
    }

    return finalUserList;
  }

  /**
   *
   * @param {object} obj - Object containing the items that may need to be added
   * @param {array} arr - Array of items to compare against obj
   * @param {string} comparator - The property to compare between obj and arr
   * @returns {array} - Array of items that are in obj, but not in arr
   */
  findItemsToAddToArray(obj, arr, comparator) {
    let itemsToAdd = [];
    // Calculate the items from the object that are already in the array
    for (const key in obj) {
      if (!arr.find((item) => item[comparator] == key)) {
        itemsToAdd.push({ [comparator]: key });
      }
    }
    return itemsToAdd;
  }

  showAllUsers() {
    this.filterToTimeBucketUsers = false;
    this.showTimeBucketUsersOption = true;
  }

  showTimeBucketUsers() {
    this.filterToTimeBucketUsers = true;
    this.showTimeBucketUsersOption = false;
  }

  showInfoButton() {
    return ['_score', '_residual_score'].includes(this.attribute_name);
  }

  getInfoButtonTooltip() {
    switch (this.attribute_name) {
      case '_score':
      case '_residual_score':
        return 'Click to learn more';
      default:
        return '';
    }
  }

  handleInfoButtonClick() {
    switch (this.attribute_name) {
      case '_score':
      case '_residual_score':
        window.open('https://guide.katapultengineering.com/calibration-scoring', '_blank');
        break;
      default:
        break;
    }
  }

  openJob(e) {
    e.preventDefault();
    if (this._value) {
      let pageType = self.isMobile ? 'mobile' : 'map';
      OpenPage(pageType, {
        target: '_blank',
        hash: this._value
      });
    }
  }

  calcLabel(label, modelLabel, attributeName, camelCase) {
    if (label) return label;
    if (modelLabel) return modelLabel;
    if (camelCase) return CamelCase(attributeName);
    return attributeName;
  }

  calcTableHeaderLabel(attributeName, camelCase) {
    const model = this.otherAttributes?.[attributeName];
    return this.calcLabel(null, model?.label, attributeName, camelCase);
  }

  calcPlaceholder(label, _label, placeholder, defaultAttributePlaceholders) {
    if (label) return label;
    if (placeholder) return placeholder;
    // Fall back to the attribute name unless the model explicitly turns that off
    if (defaultAttributePlaceholders !== false) return _label;
    return '';
  }

  capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  downGuySizesArrayChanged() {
    var values = '';
    for (var i = 0; i < this.downGuySizesArray.length; i++) {
      if (this.downGuySizesArray[i].value != null) {
        if (values !== '') {
          values += ', ';
        }
        values += this.downGuySizesArray[i].value;
      }
      this._value = values;
    }
  }

  formatDate(time) {
    return time ? FormatDate(time) : '';
  }

  formatInputDate(time) {
    // Date value from an input element is in the form YYYY-MM-DD instead of MM/DD/YYYY.
    if (time) {
      try {
        // If we have a time zone configured, convert timestamp to DateTime in the model's time zone
        if (this.modelTimeZone) {
          const dateTime = msToDateTimeInTimeZone(time, this.modelTimeZone);
          return dateTime?.toFormat('yyyy-MM-dd');
        }
      } catch (e) {
        console.error(`Unable to cast value of "${time}" a timestamp`, e);
      }
      let temp = this.formatDate(time);
      let parts = temp.split('/');
      return parts[2] + '-' + parts[0] + '-' + parts[1];
    }
    return '';
  }

  getDateLabel(placeholder, noLabelFloat) {
    return noLabelFloat ? '' : placeholder;
  }

  setDateToValue(e) {
    if (e.target.validate()) {
      if (e.detail.value) {
        // If the model has a time zone configured, then convert the date
        // value to the utc timestamp in the model's time zone
        if (this.modelTimeZone) {
          this._value = dateToMsInTimeZone(e.detail.value, this.modelTimeZone);
          return;
        }
        let parts = e.detail.value.split('-');
        let temp = Date.parse(parts[1] + '/' + parts[2] + '/' + parts[0]);
        if (!isNaN(temp) && e.detail.value == this.formatInputDate(temp)) {
          this._value = temp;
        }
      } else this._value = null;
    }
  }

  getObjectValue(_value, item) {
    return _value?.attributes?.[item.property] ?? '';
  }

  objectValueChange(e) {
    const property = e.model.item.property;
    if (!property) return;

    const newValue = e.currentTarget.value;
    // If the attributes object already exists, just set the value
    if (this._value?.attributes) this.set(`_value.attributes.${property}`, newValue);
    // Otherwise, create the object with the new set
    else this.set(`_value.attributes`, { [property]: newValue });
  }

  groupValueChange(e) {
    if (this._value == null) {
      this.set('_value', { [e.detail.attribute_name]: e.detail.value });
    } else {
      this.set('_value.' + e.detail.attribute_name, e.detail.value);
    }
  }

  stopPropagation(e) {
    var valid =
      (e.keyCode > 47 && e.keyCode < 58) || // number keys
      e.keyCode == 32 ||
      e.keyCode == 13 || // spacebar & return key(s) (if you want to allow carriage returns)
      (e.keyCode > 36 && e.keyCode < 41) || // arrow keys
      (e.keyCode > 64 && e.keyCode < 91) || // letter keys
      (e.keyCode > 95 && e.keyCode < 112) || // numpad keys
      (e.keyCode > 185 && e.keyCode < 193) || // ;=,-./` (in order)
      (e.keyCode > 218 && e.keyCode < 223); // [\]' (in order)

    // don't stop propagation if it's a tilde in a diameter measurement field or checkbox
    // don't stop propagation if it's alt or ctrl anything but arrow keys
    if (
      !e.altKey &&
      (!e.ctrlKey || (e.keyCode > 36 && e.keyCode < 41)) &&
      !(
        e.keyCode == 192 &&
        (this.gui_element == 'calibrated-width' ||
          this.gui_element == 'checkbox' ||
          this.attribute_name == 'manual_height' ||
          this.attribute_name == 'label')
      ) &&
      valid
    ) {
      e.stopPropagation();
    }
  }

  fireFileEvent(e) {
    this.dispatchEvent(new CustomEvent('file-input-changed', { detail: { value: e.target.files } }));
    const files = e.target.files ?? [];
    this._value = files.length > 0 ? true : null;
  }

  isString(value) {
    return typeof value === 'string';
  }

  getTextValue(value) {
    var text = '';
    if (this.attribute_name == 'pole_tag') {
      text = (value.company || '') + ' ' + (value.tagtext || '') + (value.owner ? ' (owner)' : '');
    } else if (typeof value == 'object') {
      for (var key in value) {
        if (text != '') text += '; ';
        text += key + ' : ' + value[key];
      }
    } else {
      text = value;
    }
    return text;
  }

  getCamelCase(attribute_name, camelCase) {
    if (camelCase) {
      return CamelCase(attribute_name);
    } else {
      return attribute_name;
    }
  }

  valueChanged() {
    if (this.ignoreNextValueChange) {
      this.ignoreNextValueChange = false;
    } else {
      if (!DeepEqual(this._value, this.value)) {
        this.ignoreNext_valueChange = true;
        this._value = Path.copy(this.value);
      }
    }
  }

  _valueChanged() {
    // Short-circuit if this change should be ignored
    if (this.ignoreNext_valueChange) {
      this.ignoreNext_valueChange = false;
      return;
    }

    // Fire the change event (previously was debounced text inputs, but now we wait for input blur / submission)
    this.fireChangeEvent();
  }

  /** Custom keydown event handler for the textarea input */
  handleTextareaKeydown(e) {
    if (e.key == 'Delete') e.stopPropagation();
    if (e.key == 'Enter' && e.ctrlKey) this._set_value(e);
  }

  /** Update local _value with parent element's internal value */
  _set_value(e) {
    const _value = e.currentTarget.value;
    const setSubpath = e.currentTarget.dataset.setSubpath ?? '';
    this.set(`_value${setSubpath}`, _value);
  }

  fireChangeEvent() {
    let oldValue = this.value;
    let temp = Path.copy(this._value);
    // First check is a dumb check for NaN, then a check for null
    if (temp !== temp || temp == null) temp = '';

    // Only fire the change event if something has actually changed
    if (!DeepEqual(this.value, temp)) {
      this.ignoreNextValueChange = true;
      this.value = temp;
      this.dispatchEvent(
        new CustomEvent('input-element-change', {
          detail: {
            attribute_name: this.attribute_name,
            value: this.value,
            oldValue: oldValue
          }
        })
      );
    }
  }

  showAllOptions() {
    let dropdown = this.shadowRoot.querySelector('#element');
    if (!(dropdown instanceof KatapultDropDown || dropdown instanceof KatapultMultiDropDown)) throw new Error('Element is not a dropdown');
    dropdown.temporarilyShowAllItems();
    this.selectedPicklist = null;
  }

  boundGetPicklistItemLabel(item) {
    if (typeof item == 'string') return item;
    return item?.label ?? item?.value ?? '';
  }

  modelChanged() {
    this.noModel = this.model == null || !Object.getOwnPropertyNames(this.model).length;
    if (this.noModel) {
      this.gui_element = null;
      this.picklist = [];
      this.labelKey = 'value';
      return;
    }

    this.gui_element = this.model.gui_element || this.model._gui_element;
    let picklist = this.model.picklist ?? this.model._picklist ?? [];
    let picklists = this.model.picklists;

    // Handle special company-type GUI elements
    if (['pole_tag', 'cost-causer', 'power-consumption'].includes(this.gui_element)) {
      picklists = this.get('otherAttributes.company.picklists');
      if (this.gui_element == 'pole_tag') {
        // Filter company list by "pole_tag_company" if that key is set
        const filteredPicklists = {};
        let count = 0;
        for (const key in picklists) {
          filteredPicklists[key] = picklists[key].filter((x) => x.pole_tag_company);
          count += filteredPicklists[key].length;
        }
        if (count > 0) {
          picklists = filteredPicklists;
        }

        // If it's a pole tag, sort the power companies to the top
        picklists = ToArray(picklists).sort((x) => {
          if (x.$key.toLowerCase().includes('power')) return -1;
          else return 1;
        });
      }
    }

    const modelHasReferencedPicklist = this.model.referenced_picklist;
    let referencedPicklist =
      this.get(`otherAttributes.${this.model.referenced_picklist}.picklists`) ||
      this.get(`otherAttributes.${this.model.referenced_picklist}.picklist`);
    if (modelHasReferencedPicklist) {
      // If the input model has a referenced picklist, get the picklist from the referenced attribute (fallback to the picklist key for legacy attributes like 'over')
      picklists = referencedPicklist;
    }
    if (picklists != null) {
      for (const key in picklists) {
        const selectPicklistIsNull = this.selectedPicklist == null;
        const picklistMatchesSelectedPicklist = key == this.selectedPicklist;
        const referencedPicklistHasSelectedPicklist = referencedPicklist?.[this.selectedPicklist] ?? false;
        if (
          selectPicklistIsNull ||
          (modelHasReferencedPicklist && !referencedPicklistHasSelectedPicklist) ||
          picklistMatchesSelectedPicklist
        ) {
          picklist = picklist.concat(picklists[key]);
        }
      }
    }
    if (picklist != null && picklist[0] != null) {
      if (typeof picklist[0] === 'string') {
        this.labelKey = this.valueKey = '';
      } else if (picklist[0].value != null && picklist[0].label == null) {
        this.labelKey = 'value';
        this.valueKey = 'value';
      } else {
        this.labelKey = 'label';
      }
    }
    if (this.model.picklist_value_path != null) this.valueKey = this.model.picklist_value_path;
    if (this.model.picklist_label_path != null) this.labelKey = this.model.picklist_label_path;
    this.picklist = picklist;
    if (this.model.value != null && this.value == null) {
      this.value = this.model.value;
    }
  }

  fetchModelData(jobCreator, gui_element, firebaseDisabled) {
    this.detachTimeZoneListener?.();
    if (!jobCreator || !gui_element || firebaseDisabled) return;
    if (gui_element != 'date') return;
    this.detachTimeZoneListener = KatapultModel.fromId(jobCreator).onTimeZoneSnapshot((s) => {
      this.modelTimeZone = s.val();
    });
  }

  // Fill in modelConfig from the job creator's model, refetching when the job creator changes.
  async updateModelConfigFromJobCreator(jobCreator) {
    // Skip a caller supplied modelConfig and a job creator already fetched.
    const isModelConfigExplicitlySupplied = this.modelConfig && this.modelConfig !== this._fetchedModelConfig;
    if (!jobCreator || isModelConfigExplicitlySupplied || jobCreator === this._fetchedModelConfigJobCreator) return;

    // Fetch the config, discarding it if the job creator changed again during the fetch.
    this._fetchedModelConfigJobCreator = jobCreator;
    const fetchedModelConfig = await KatapultModel.fromId(jobCreator).getConfigMap();
    if (jobCreator !== this._fetchedModelConfigJobCreator) return;

    this.modelConfig = this._fetchedModelConfig = fetchedModelConfig;
  }

  _disabledChanged() {
    if (this.editingLink) this.editLink();
  }

  autoFocusChanged() {
    setTimeout(() => {
      if (this.autoFocus) {
        var element = this.shadowRoot.querySelector('#element');
        if (element != null) {
          element.focus();
        }
      }
    }, 1);
  }

  focusElement() {
    setTimeout(() => {
      var element = this.shadowRoot.querySelector('#element');
      if (element != null) {
        element.focus();
      }
    }, 50);
  }

  computeDisabled() {
    // This assignment is two stage to circumvent _disabled being undefined and thus breaking some frontend attributes
    this._disabled = Boolean(this.disabled || (this.model?.read_only && !this.ignoreReadOnly));
  }

  buttonClick(e) {
    this.dispatchEvent(new CustomEvent('button-click', { detail: e.currentTarget.getAttribute('name') }));
  }

  async dropdownIconClick(e) {
    if (e.detail.originalEvent?.model?.icon?.photo) {
      e.detail.originalEvent.stopPropagation();
      let url = await firebase
        .storage()
        .ref(`company_files/${this.userGroup}/attribute_example_images/${e.detail.originalEvent.model.icon.photo}`)
        .getDownloadURL();
      this.dispatchEvent(new CustomEvent('open-photo', { detail: { url }, bubbles: true, composed: true }));
    }
  }

  enterPressed() {
    this.dispatchEvent(new CustomEvent('submit'));
  }

  keyPressed(e) {
    // Allow the default behavior for the delete key
    if (e.keyCode == 46) e.stopPropagation();

    if (this.gui_element == 'textbox_commit' && e.keyCode == 13) this.commitValueChange();
    else if (e.keyCode == 13) {
      this.dispatchEvent(new CustomEvent('submit'));
    }
  }

  selectText(event) {
    if (event) {
      let polymerEvent = event;

      if (polymerEvent) {
        let target = polymerEvent.target;
        if (target) {
          let input = null;
          if (target.tagName == 'PAPER-INPUT') {
            input = target?.$?.input ?? '';
            if (input) {
              input = input.querySelector('input');
            }
          }
          if (target.tagName == 'PAPER-TEXTAREA') {
            // For mobile assessment inputs, leave the caret where the user tapped instead of selecting all.
            if (!this.isMobileAssessmentInput) input = target?.$?.input?.$?.textarea ?? '';
          }

          if (input) {
            input.select();
          }
        }
      }
    }

    if (self.isMobile && this.attribute_name === 'sizes_of_attached_dn_guys') {
      this.downGuyMobileInputOpened = true;
    }
  }

  formatTime(time) {
    if (time == null) {
      return '';
    }
    var date = new Date(time);
    var hours = ('0' + date.getHours()).slice(-2);
    var minutes = ('0' + date.getMinutes()).slice(-2);
    var seconds = ('0' + date.getSeconds()).slice(-2);
    return hours + ':' + minutes + ':' + seconds;
  }

  getDate(value) {
    var start = this.toDateString(value.start) || '';
    var stop = this.toDateString(value.stop) || '';
    if (stop == '' || start == stop) {
      return start + ' ';
    } else if (start != '' && stop != '') {
      return start + ' - ' + stop + ' ';
    }
  }

  getFileInputPath(fileInputPath, attr, path) {
    return fileInputPath || path || attr;
  }

  toDateString(time) {
    if (time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return year + '-' + month + '-' + day;
    }
    return null;
  }

  nullDownGuyInputValues(e) {
    e.stopPropagation();
    setTimeout(() => {
      this.downGuyMobileInputOpened = false;
    });
    this.number_of_attached_down_guys = null;
    this.set('downGuySizesArray', []);
  }

  captureEvent(e) {
    e.stopPropagation();
  }

  calcShowElement(model, disabled, hideOnDisabled, value) {
    return (
      !disabled ||
      model == null ||
      !hideOnDisabled ||
      (model.required_permission != 'write' &&
        ((value !== '' && value !== false) || model.gui_element == 'checkbox' || model._gui_element == 'checkbox'))
    );
  }

  getHelpButtonDisabled(model) {
    const hasHelpTextOrLink = model?.help_text || model?.help_link;
    return !hasHelpTextOrLink && !this.userCanEditModel;
  }

  getHelpButtonIconConfig(model) {
    const buttonIsDisabled = this.getHelpButtonDisabled(model);
    if (buttonIsDisabled) return {};
    const hasHelpTextOrLink = model?.help_text || model?.help_link;
    if (!hasHelpTextOrLink) {
      return { color: 'var(--sl-color-neutral-400)' };
    }
  }

  attributeInfoButtonClickHandler(e) {
    // If there is an existing attribute info dialog, close it and return.
    // Otherwise, open a new attribute info dialog.
    if (this.attributeInfoDialog) {
      this.attributeInfoDialog.close();
      return;
    }

    /**
     * Sanitizes a help link to ensure it has a proper protocol prefix.
     * @param {string} link
     * @returns {string}
     */
    const sanitizeHelpLink = (link) => {
      if (!link.includes('//')) return `//${link}`;
      return link;
    };

    const { help_text: helpText } = this.model ?? {};
    const helpLink = this.model?.help_link ? sanitizeHelpLink(this.model?.help_link) : undefined;

    const html = litHtml;
    this.attributeInfoDialog = KatapultDialog.open({
      dialog: {
        draggable: true,
        closeButton: true,
        noResetPosition: true,
        onlyDragFromHandle: true,
        color: 'white',
        maxWidth: 400,
        minHeight: 100,
        minWidth: 180,
        transform: 'translateX(24px) scale(0.98)'
      },
      template: () => html`
        <div slot="header-center-start" style="display:flex; align-items: center; font-weight:bold;">${CamelCase(this.attribute_name)}</div>
        <sl-tooltip slot="header-right-start" content="Help Link" placement="top" hoist>
          <katapult-button
            .disabled="${!helpLink}"
            iconOnly
            noBorder
            icon=${helpLink ? 'link' : 'link_off'}
            style="flex-shrink: 0;"
            @click=${() => window.open(helpLink, '_blank', 'noopener,noreferrer')}
          ></katapult-button>
        </sl-tooltip>

        ${when(
          this.userCanEditModel,
          () => html`
            <sl-tooltip slot="header-right-start" content="Edit Attribute" placement="top" hoist>
              <katapult-button
                id="editHelpText"
                iconOnly
                noBorder
                icon="create"
                style="flex-shrink: 0;"
                @click=${() => {
                  OpenPage('model-editor', {
                    hash: `${this.jobCreator ?? ''}/attributes/${this.attribute_name ?? ''}`,
                    target: '_blank'
                  });
                }}
              ></katapult-button>
            </sl-tooltip>
          `
        )}
        <div>
          ${when(
            helpText,
            () => html`<div style="white-space: pre-wrap;">${helpText}</div>`,
            () =>
              when(
                helpLink,
                () => html`<div style="font-style: italic; text-align: center;">See link above for more info</div>`,
                () =>
                  when(
                    this.userCanEditModel,
                    () =>
                      html`<div style="font-style: italic; text-align: center;">Use the pencil icon to edit help text or help link</div>`
                  )
              )
          )}
        </div>
      `
    });
    this.attributeInfoDialog.position = { x: e.clientX - 220, y: e.clientY };
    this.attributeInfoDialog.addEventListener('closed', () => (this.attributeInfoDialog = null), { once: true });
  }

  async computeUserCanEditModel(jobCreator, showHelp) {
    // Avoid unnecessary API calls: only call UserCanEditModel when showHelp is true and
    // jobCreator is set, and when these inputs actually change.
    if (!showHelp || !jobCreator || !katapultAuth?.user?.uid) {
      this.userCanEditModel = false;
      return;
    }
    // If the inputs have not changed since the last check, reuse the existing value.
    if (this._lastUserCanEditModelJobCreator === jobCreator && this._lastUserUid === katapultAuth?.user?.uid) {
      this.userCanEditModel = this._lastUserCanEditModel;
      return;
    }
    this._lastUserCanEditModelJobCreator = jobCreator;
    this._lastUserUid = katapultAuth?.user?.uid;
    this._lastUserCanEditModel = this.userCanEditModel = await UserCanEditModel(katapultAuth?.user?.uid, jobCreator);
  }

  _computeClass(gui_element, topLabel) {
    return this.tokenList({ hidden: gui_element == 'hidden', topLabel: topLabel || gui_element == 'table' });
  }

  calcElementIsHidden(gui_element) {
    return gui_element == 'hidden';
  }

  calcShowTextbox(gui_element, disabled) {
    return gui_element == 'textbox' && !disabled;
  }

  calcShowTextboxCommit(gui_element, disabled) {
    return gui_element == 'textbox_commit' && !disabled;
  }

  calcShowTextarea(gui_element, disabled) {
    return gui_element == 'textarea' || ((gui_element == 'textbox' || 'gui_element' == 'textbox_commit') && disabled);
  }

  _computeStyle(model) {
    return 'color:' + (model && model.color) || 'black' + ';';
  }

  getModel(item) {
    return this.get('otherAttributes.' + item);
  }

  getModelIcon(model) {
    return (model && model.icon) || 'my_location';
  }

  getStartStopText(_valueChange) {
    if (_valueChange.value.start == null) {
      return 'start';
    } else if (_valueChange.value.stop == null && _valueChange.value.start != null) {
      return 'stop';
    } else if (_valueChange.value.stop != null && _valueChange.value.start != null) {
      return 'new';
    }
  }

  _computeExpression6(_value, label) {
    return _value[label].latitude;
  }

  _computeExpression7(_value, label) {
    return _value[label].longitude;
  }

  tokenList(obj) {
    var pieces = [];
    for (var key in obj) {
      if (obj[key]) {
        pieces.push(key);
      }
    }
    return pieces.join(' ');
  }

  _compareAttribute(attribute, name) {
    if (attribute === name) return true;
    return false;
  }

  _addOneToNumber(index) {
    return index + 1;
  }

  getTiles(_value) {
    if (typeof _value === 'string') {
      var tiles;
      if (_value.indexOf(',') > -1) {
        tiles = _value.split(',');
      } else {
        tiles = [_value];
      }
      return tiles;
    }
  }

  deleteTile(e) {
    var index = e.model.index,
      tiles = '';
    if (this._value.indexOf(',') > -1) {
      var temp = this._value.split(',');
      temp.splice(index, 1);
      for (let i = 0; i < temp.length; i++) {
        if (i == 0) tiles += temp[i];
        else tiles += ',' + temp[i];
      }
    } else {
      tiles = '';
    }
    this.set('_value', tiles);
  }

  focusSearch(e) {
    this.dispatchEvent(new CustomEvent('search-focused', { detail: { currentTarget: e.currentTarget } }));
  }

  openedChanged(e) {
    this.dispatchEvent(new CustomEvent('drop-down-opened-changed', e));
  }

  _normalizeLinkValue() {
    if (!this._value) return;

    let value = String(this._value).trim();
    if (value) {
      // Handle protocol-relative URLs such as //example.com
      if (value.startsWith('//')) {
        value = `https:${value}`;
      } else {
        const lower = value.toLowerCase();
        const hasAllowedScheme =
          lower.startsWith('http://') || lower.startsWith('https://') || lower.startsWith('mailto:') || lower.startsWith('tel:');
        // If there is no allowed scheme and no other explicit scheme via "://",
        // default to https:// so the URL is not treated as relative.
        if (!hasAllowedScheme && !value.includes('://')) {
          value = `https://${value}`;
        }
      }
    }

    this._value = value;
  }

  editLink() {
    // When leaving edit mode, ensure the URL has a protocol so the browser
    // doesn't resolve it as a relative path against the current domain.
    if (this.editingLink) this._normalizeLinkValue();

    this.editingLink = !this.editingLink;
  }

  _onLinkBlur() {
    this._normalizeLinkValue();
    this.editingLink = false;
  }

  shouldShowLinkEditInput(editingLink, value, disabled) {
    return Boolean(editingLink) || (!disabled && (value == null || String(value).trim() === ''));
  }

  async openTable(e) {
    if (e.currentTarget) {
      let target = e.currentTarget;
      target.loading = true;
      await import('./table-attribute-editor.js');
      target.loading = false;
    }
    let editor = this.shadowRoot.querySelector('#tableEditor');
    let itemKey = typeof e == 'string' ? e : e.model.row;
    editor.property = CamelCase(this.attribute_name);
    this.set('itemKey', itemKey);
    editor.model = this.model;
    editor.open();
  }

  async addTableRow(e) {
    let target = e.currentTarget;
    target.loading = true;
    await import('./table-attribute-editor.js');
    target.loading = false;
    let value = GetNewAttributeValue(this.attribute_name, this.otherAttributes);
    //Check to see if the last row is empty/has default values, if so, open it;
    let lastIsEmpty = false;
    let keys = Object.keys(this._value || {});
    let lastKey;
    if (keys.length > 0) {
      lastKey = keys[keys.length - 1];
      let lastValue = this._value[lastKey];
      lastIsEmpty = true;
      for (let itemKey in lastValue) {
        if (lastValue[itemKey] != value[itemKey]) {
          lastIsEmpty = false;
          break;
        }
      }
    }
    if (!lastIsEmpty) {
      let itemKey = FirebaseWorker.ref().push().key;
      this.set('_value.' + itemKey, value);
    }
  }

  itemKeyChanged(k) {
    if (this.editor) this.editor.itemKey = k;
  }

  notifyResize() {
    if (this.gui_element == 'dropdown') {
      let elem = this.shadowRoot.querySelector('#element');
      elem.updatePosition();
    }
  }

  showTableHeader(display, type, disabled) {
    return display && (type != 'icon-button' || !disabled);
  }

  showIconButton(type, disabled) {
    return type == 'icon-button' && !disabled;
  }

  tableButtonAction(e) {
    this.dispatchEvent(
      new CustomEvent('table-button-action', {
        detail: {
          property: this.attribute_name,
          itemKey: e.model.row,
          functionName: e.model.item.function,
          models: e.model.item
        },
        bubbles: true,
        composed: true
      })
    );
  }

  textboxCommitChanged(e) {
    this.showTextboxCommitButtons = this._value != e.detail.value;
  }

  commitValueChange(e) {
    this.set(`_value`, this.shadowRoot.querySelector('#element').value);
    this.showTextboxCommitButtons = false;
  }

  discardValueChange(e) {
    this.shadowRoot.querySelector('#element').updateValueAndPreserveCaret(this._value);
    this.showTextboxCommitButtons = false;
  }
  tableValueChanged(e) {
    this.set(`_value.${e.model.__data.row}.${e.model.__data.item.attribute}`, e.detail.value);
  }

  /**
   * Validates the input value against the regex string provided in the model's validation object. Only validates if the input is in a
   * matching context and the GUI element is one that should be validated.
   * @param {CustomEvent | PolymerDeepPropertyChange} eventOrChangeRecord - The event or change record that triggered the validation
   */
  validate(eventOrChangeRecord) {
    // Get the value from the event or change record
    const value = 'target' in eventOrChangeRecord ? eventOrChangeRecord.detail.value : eventOrChangeRecord.value;
    const isValid = validateValue(value, this.model, { isMobileAssessmentInput: this.isMobileAssessmentInput });
    if (isValid === undefined) return;

    // Update the invalid property based on the validation result
    this.invalid = !isValid;
  }
}

/**
 * Validates an attribute value against the regex string provided in the attribute model's validation object.
 * @param {any} value - An attribute value to validate
 * @param {object} attributeModel - The model object for the attribute
 * @param {object} options - Options for the validation check
 * @param {boolean} options.isMobileAssessmentInput - Whether the input should be validated as though it were in a mobile assessment
 * @returns {boolean | undefined} `true` if the value is valid, `false` if it is not, and `undefined` if the value could not be validated
 */
export function validateValue(value, attributeModel, { isMobileAssessmentInput = false }) {
  const hasValidation = attributeModel?.validation?.regex_string;
  if (!hasValidation) return;

  const validationContext = attributeModel.validation.validation_context;
  // This is a little confusing, but it handles the case where validation is configured but the context is not set (which is how it was
  // before the validation_context property was added to the validation object).
  const inMatchingContext = (validationContext === 'EVERYWHERE' || isMobileAssessmentInput) && validationContext !== 'NEVER';
  const shouldValidate = inMatchingContext && GUI_ELEMENTS_WITH_VALIDATION.includes(attributeModel.gui_element);
  if (!shouldValidate) return;

  const regexString = attributeModel.validation.regex_string;
  return new RegExp(regexString).test(value || '');
}

customElements.define('input-element', InputElement);
